// Interfaces
import { IRouteParent } from 'routes/route.interface'

// Constant
import { QA_MODULE, QA_URL } from 'constant/url.constant'
import { ACCESS_CODE_QA } from 'constant/access.constant'

// QA Index Router
import { qaIndexRoutes } from './qa.router'

const qaRoutes: IRouteParent = {
  path: QA_URL.INDEX,
  meta: {
    attrs: {
      module: QA_MODULE,
      icon: 'back-office/icon-qa',
      label: 'backOffice.qa',
      accessCodes: ACCESS_CODE_QA,
    },
  },
  children: [...qaIndexRoutes],
}

export { qaRoutes }
